<template>

<div class="content">

  <a href="/">
    <img src="img/logo.webp" class="logo_img" alt="">

    <div class="text_area">
    <img src="img/main_text.svg" class="main_text" alt="">
    <img src="img/secondary_text.svg" class="secondary_text" alt="">
  <img src="img/button.svg" class="button" alt="">
    </div>
  </a>

  <img src="img/main_characters.webp" class="main_characters" alt="">
  <img src="img/elem1.webp" class="elem1" alt="">
    <img src="img/elem2.webp" class="elem2" alt="">
    <img src="img/elem3.webp" class="elem3" alt="">
    <img src="img/elem4.webp" class="elem4" alt="">
  <img src="img/elem5.webp" class="elem5" alt="">
</div>
</template>

<script>


export default {

  methods: {
    example(example) {
      location.hash = "#" + example;
    },
  }
}
</script>


<style lang="stylus">

.content
  position: absolute;
  width 100%
  height: 100%;
  background: linear-gradient(270deg, #110E1B 0%, #0047FF 28%, #110E1B 100%);


img
  position: absolute;
  left: 50%;
  width auto



.logo_img
  transform: translate(-50%);
  height: 9.5%;
  top: 2%;
  z-index: 10;

.main_text
  transform: translate(-156%);
  height: 33%;
  top: 19%;

.secondary_text
  transform: translate(-330%);
  height: 11.2%;
  top: 59%;

.button
  transform: translate(-194%);
  height: 8.2%;
  top: 77.3%;
  z-index 20
  cursor: pointer;
  transition filter .5s linear

.button:hover
  filter brightness(.9)


.main_characters
  transform: translate(-34%);
  height: 103%;
  top: -3%;
  z-index 3

.elem1
  transform: translate(-195%);
  height: 21%;
  top: 0;
  z-index: 5;

.elem2
  transform: translate(404%);
  height: 14%;
  top: 13.3%;
  z-index: 5;

.elem3
  transform: translate(-939%);
  height: 8%;
  top: 48%;
  z-index: 5;

.elem4
  transform: translate(-186%);
  height: 15%;
  top: 85%;
  z-index: 5;

.elem5
    display none

@media (max-width: 1380px)
  .text_area
     position absolute
     width: 100%;
     height: 100%;
     left: 50px;
     z-index 10
  .main_characters
     transform translate(-38%)

@media (max-width: 1260px)
  .text_area
    left: 100px;
  .main_characters
    transform translate(-40%)

@media (max-width: 1160px)
  .text_area
    left: 150px;
  .main_characters
    transform translate(-40%)

@media (max-width: 1060px)
  .text_area
    left: 0;
  .main_characters
    transform: translate(-57%);
    height: 52%;
    top: 51%;
    z-index: 3;
  .logo_img
    height: 6.5%;
  .main_text
    transform: translate(-50%);
    height: 22%;
    top: 13%;
  .secondary_text
    transform: translate(-83%);
    height: 9.5%;
    top: 39.7%;
  .button
    transform: translate(-50%);
    height: 6.8%;
    top: 53.2%;
  .content
    overflow hidden
  .elem1
    transform: translate(-183%);
    height: 12%;
    top: -4%;
  .elem2
    transform: translate(162%);
    height: 10%;
    top: 4.3%;
  .elem3
    transform: translate(-356%);
    height: 6.5%;
    top: 34%;
  .elem4
    display none
  .elem5
    display: block;
    transform: translate(156%);
    height: 13.5%;
    top: 59%;
  .content
    background: linear-gradient(90deg, #10122A 0%, #0147FC 67%, #002689 100%);











</style>
